import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './annuals.types';

export const annualsSelectors = {
  ...generateResourceSelectors<types.IAnnual>((state) => state.resource.annuals),
};
